// src/components1/AddChoiceSheet.js
import React from "react";

/**
 * The two ways to add, offered above the + button: say it, or fill the form.
 * Dismissing it anywhere else leaves the page exactly as it was.
 */
const AddChoiceSheet = ({ onVoice, onManual, onClose, closing = false, example = "50 dollars groceries at Kroger" }) => (
  <div
    className={`add-choice-overlay${closing ? " is-closing" : ""}`}
    onClick={onClose}
    role="presentation"
  >
    <div className="add-choice-stack" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="add-choice-btn is-voice" onClick={onVoice}>
        <span className="add-choice-icon">
          <i className="fi fi-rr-microphone"></i>
        </span>
        <span className="add-choice-text">
          <span className="add-choice-title">Say it</span>
          <span className="add-choice-sub">&ldquo;{example}&rdquo;</span>
        </span>
      </button>

      <button type="button" className="add-choice-btn is-manual" onClick={onManual}>
        <span className="add-choice-icon">
          <i className="fi fi-rr-edit"></i>
        </span>
        <span className="add-choice-text">
          <span className="add-choice-title">Type it</span>
          <span className="add-choice-sub">The form you already know</span>
        </span>
      </button>

      <div className="add-choice-hint">Tap anywhere to close</div>
    </div>
  </div>
);

export default AddChoiceSheet;
